"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { WaveOutcome } from "@/components/waves/outcome/WaveOutcome";
import { useLayout } from "./layout/LayoutContext";
interface MyStreamWaveOutcomeProps {
  readonly wave: ApiWave;
}

// Removed in favor of useWaveViewHeight hook

const MyStreamWaveOutcome: React.FC<MyStreamWaveOutcomeProps> = t0 => {
  const $ = _c(7);
  const {
    wave
  } = t0;
  const {
    outcomeViewStyle
  } = useLayout();
  let t1;
  if ($[0] !== wave.outcomes) {
    t1 = wave.outcomes.map(_temp);
    $[0] = wave.outcomes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tw-px-2 sm:tw-px-4 tw-space-y-4">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== outcomeViewStyle || $[5] !== t2) {
    t3 = <div className="tw-pt-4 tw-pb-4 tw-w-full tw-flex tw-flex-col tw-overflow-y-auto no-scrollbar lg:tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300 tw-flex-grow lg:tw-pr-2" style={outcomeViewStyle}>{t2}</div>;
    $[4] = outcomeViewStyle;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default MyStreamWaveOutcome;
function _temp(outcome, index) {
  return <WaveOutcome key={`${outcome.credit}-${outcome.type}-${index}`} outcome={outcome} />;
}